
const api = {	
	getAgreePackage: "/bss/app/noauth/QueryAgreeOfferList", // 获取关联销售品接口
	preCalcOrder:"/bss/app/order/PreCalcOrder",           //下单时预计算订单费用
	queryAgreement: "/bss/app/payagreement/queryAgreement", // 查询用户连续畅想套餐的协议
	queryPromotionInst: "/bss/app/promotion/queryPromotionInst",                //查询个人促销码实例接口
	queryPromotionInfo: "/bss/app/promotion/GetPromotionInfo",                    //查询公共促销码实例接口
    queryAutoPublicPromotion: "/bss/app/promotion/QueryAutoPublicPromotion",    //查询自动关联查出的公共促销码实例接口
    queryCustPromotionByGoods:"/bss/app/promotion/queryCustPromotionByGoods", ///用于APP查询个人订单可用及不可用促销码，返成功仅表示优克联侧业务处理成功。
    account_unbindAgreement: "/bss/app/payagreement/unbindAgreement", // 用户解约连续畅想套餐的协议
    getPromotion:"/bss/app/act/actDetailListByGoodsCode", //营销活动
}


export default {
    install(Vue, options){
        Vue.prototype.$api = api;

    }
}